module.exports = __webpack_public_path__ + "img/1526718847.ebb70edd.jpg";